import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiShield, FiMenu, FiX } from 'react-icons/fi';
import { useNavItems } from '../hooks/useNavItems';

const UserHeader = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const location = useLocation();

  const navItems = useNavItems([
    { to: '/user/dashboard', label: 'Dashboard', feature: 'cud_dashboard' },
    { to: '/user/assessments', label: 'Assessments' },
    { to: '/user/requests', label: 'Requests' },
  ]);

  return (
    <>
    <header className={`bg-white border-slate-200 border-b sticky top-0 z-40`}>
      <div className="flex items-center justify-between px-6 h-16">
        {/* Logo */}
        <Link to="/user/dashboard" className="flex items-center gap-3">
        
          <div className="hidden md:block">
            <h1 className={`text-2xl font-bold text-[#0077b5]`}>Trust Center</h1>
           
          </div>
        </Link>

        {/* Desktop Navigation + Send a request button */}
        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-4 py-3 text-sm font-medium transition-colors border-b-2 whitespace-nowrap ${
                location.pathname === item.to
                  ? 'border-[#ff6600] text-[#ff6600]'
                  : 'border-transparent text-slate-600 hover:text-slate-800'
              }`}
            >
              {item.label}
            </Link>
          ))}

        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          className={`md:hidden p-2 rounded-lg transition-colors hover:bg-slate-100 text-slate-600`}
        >
          {showMobileMenu ? <FiX className="text-lg" /> : <FiMenu className="text-lg" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {showMobileMenu && (
        <nav className={`md:hidden border-t border-slate-200 bg-slate-50/50`}>
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === item.to
                    ? 'bg-blue-50 text-[#ff6600]'
                    : 'text-slate-600 hover:text-slate-800 hover:bg-slate-100'
                }`}
                onClick={() => setShowMobileMenu(false)}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>

    </>
  );
};

export default UserHeader;
